module.exports = __webpack_public_path__ + "img/icon_shopping_nor.25f5ae41.png";